<app-header></app-header>
<section class="py-5" style=" background:url(./media/small-industry.jpg) no-repeat; background-size: cover; height: 90vh;">
  <div class="container pt-5 pb-5">
    <div class="ud-registration">
      <form [formGroup]="firstFormGroup">
        <div class="row mb-2">
          <div class="col">
            <label class="fw-semibold">Do you have a UDYAM Registration Number (URN)? <span class="text-danger">*</span></label>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-radio-group formControlName="hasURN" (change)="onSelectionChange()" aria-label="Select an option">
              <mat-radio-button value="yes"> Yes</mat-radio-button>
              <mat-radio-button value="no"> No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <br />
        <button class="btn btn-danger" id="btncancel" type="submit" [routerLink]="'/login'">Cancel</button>
      </form>
    </div>
  </div>
</section>

<app-footer></app-footer>
